import React from "react";
import { useState,useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/ApparelOrderItemList.css';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';


const columns = [
    {
        field: 'order_number',
        headerName: 'Order Number',  
        headerClassName:'order_number_header',    
        flex:1,
        minWidth: 80,
        // sortable:false,
        renderCell: (params) => (
            <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.order_number}
            </Link>
        ),
    },
    {
        field: 'description',
        headerName: 'Description',
        cellClassName:'description_column',headerClassName:'description_header',   
        flex:1, 
        minWidth: 314,
        // sortable:false,    
    },
    {
        field: 'quantity',
        headerName: 'Quantity',
        cellClassName:'quantity_column',headerClassName:'quantity_header',   
        flex:1, 
        minWidth: 80,
        // sortable:false,    
    },
    {
        field: 'paid_on',
        headerName: 'Paid On',   
        headerClassName:'paid_on_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    },
    {
        field: 'amount_paid',
        headerName: 'Amount Paid',   
        headerClassName:'amount_paid_header',
        flex:1,
        minWidth: 80,
        // sortable:false,
    },
    {
        field: 'payment_status',
        headerName: 'Payment Status',   
        headerClassName:'payment_status_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    },
    {
        field: 'shipment_status',
        headerName: 'Shipment Status',   
        headerClassName:'shipment_status_header',
        flex:1,
        minWidth: 100,
        // sortable:false,
    }
];

const ApparelOrderItemList = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const [statuscount, setStatusCount] = useState({});
    // const [searchTerm, setSearchTerm] = useState('');
    const [searchValue, setSearchValue] = useState('');

    const app_url = configData.APP_URL;

    // Filter rows based on search term
    // const filteredRows = searchTerm.trim()
    // ? rows.filter((row) => {
    //     const order_number = String(row.order_number || '').toLowerCase();
    //     const description = String(row.description || '').toLowerCase();
    //     const quantity = String(row.quantity || '').toLowerCase();
    //     const paid_on = String(row.paid_on || '').toLowerCase();
    //     const amount_paid = String(row.amount_paid || '').toLowerCase();
    //     const payment_status = String(row.payment_status || '').toLowerCase();
    //     const shipment_status = String(row.shipment_status || '').toLowerCase();
    //     const search = searchTerm.trim().toLowerCase();

    //     return (
    //         order_number.includes(search) ||
    //         description.includes(search) ||
    //         quantity.includes(search) ||
    //         paid_on.includes(search) ||
    //         amount_paid.includes(search) ||
    //         payment_status.includes(search) ||
    //         shipment_status.includes(search)
    //     );
    //     })
    // : rows;
       
    const fetchData = async () => {
        // Simulate API call to your server
        // In a real application, replace this with your actual fetch logic
        try {
        // setIsLoading(true);
        const response = await fetch(app_url+'smwwcommerceapparel/apparelorderlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel
        }),
        });
        const data = await response.json();
        // console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
        setStatusCount(data.data.status_count);
        }  catch (error) {
            console.error('Error fetching data:', error);
        // } finally {
        //     setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
              
    };
        

    // React.useEffect(() => {
    //     fetchData();
    // }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change 
    React.useEffect(() => {
        if (searchValue.trim() === '') {
        Promise.all([
           fetchData(),
        ])
        .then(() => {
        setIsLoading(false);
        })}
    }, [paginationModel, sortModel, filterModel, searchValue]);

useEffect(() => {
        const fetchQueryData = async () => {
        if (searchValue.trim() !== '') {
            // fetchData();
            // return;
        // }
        try {
            const response = await fetch(app_url+'smwwcommerceapparel/apparelorderlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  page: paginationModel.page,
                  pageSize: paginationModel.pageSize,
                  query:searchValue
                //   sortModel,
                //   filterModel
                }),
              });
            const data = await response.json();
            setRows(data.data.rows);
            setRowCount(data.data.totalRowCount);
            setStatusCount(data.data.status_count);
        } catch (error) {
            console.error('Error fetching data:', error);
        }}
        };
        const handler = setTimeout(() => {
        fetchQueryData();
        }, 500); 

        return () => {
        clearTimeout(handler);
        };
    }, [searchValue, paginationModel]);

    return (
        <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main" className="apparel-order-item-main">
                    <Helmet><title>Apparel Order Item List</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="apparel-order-item-container">
                            <div style={{fontWeight:"bold", borderBottom:"1px solid #ddd"}}>
                                <div style={{padding: "10px 15px"}}>Apparel Order Items</div>
                            </div>
                            <div style={{marginRight: "15px"}}>
                                <a target="_blank" href="/change-apparel-order-status/completed" className="btn btn-blue">Completed ({statuscount.completed})</a>
                                <a target="_blank" href="/change-apparel-order-status/shipped" className="btn btn-blue">Need to Complete ({statuscount.shipped})</a>
                                <a target="_blank" href="/change-apparel-order-status/received" className="btn btn-blue">Need to Ship ({statuscount.received})</a>
                                <a target="_blank" href="/change-apparel-order-status/waiting-for-vendor" className="btn btn-blue">Waiting for Vendor ({statuscount['waiting-for-vendor']})</a>
                                <a target="_blank" href="/change-apparel-order-status/need-to-order" className="btn btn-blue">Need to Order ({statuscount['not_planned']})</a>
                            </div>
                            <div style={{clear: "both"}}></div>
                            <div style={{padding: "15px"}}>
                                <div style={{textAlign:"right", marginRight: "10px"}} className="apparel-order-item-search">
                                    <label style={{fontWeight:"normal"}}>
                                        Search:
                                        <input 
                                            type="search" 
                                            className="" 
                                            placeholder="" 
                                            aria-controls="example" 
                                            value={searchValue} 
                                            // onChange={(e) => setSearchTerm(e.target.value)} 
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </label>
                                </div>
                            
                            <div className="" >
                                <table className="apparel-order-item-table">
                                    <div>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            rowCount={rowCount}
                                            paginationMode="server"
                                            sortingMode="server"
                                            filterMode="server"
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            sortModel={sortModel}
                                            onSortModelChange={setSortModel}
                                            filterModel={filterModel}
                                            onFilterModelChange={setFilterModel}
                                            pageSizeOptions={[5, 10, 25,50]}
                                            getRowId={() => crypto.randomUUID()}
                                            getRowHeight={() => 'auto'}
                                            disableColumnFilter 
                                            // disableColumnResize={true}
                                        />
                                    </div>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="right"></div>
                </div>
            )}
        </>
    );
};

export default ApparelOrderItemList;